import { render, staticRenderFns } from "./foot_menu.vue?vue&type=template&id=5306f280&"
import script from "./foot_menu.vue?vue&type=script&lang=js&"
export * from "./foot_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports